<ng-container *notInPopulation="[populations.Pts, populations.Suite]">
  <div class="full-page-container">
    <fgb-banner [title]="'rewards.page.title' | translate"></fgb-banner>

    <div class="d-block d-lg-none">
      <fgb-page-header [pageTitle]="'marketplace.page.title'" [backButtonLink]="'/'"></fgb-page-header>
    </div>

    <fgb-mixed-loyalty-nav></fgb-mixed-loyalty-nav>

    <div class="container mt-4">
      <fgbcl-mixed-loyalty-list [onlyFavourites]="false" [pageSize]="100"></fgbcl-mixed-loyalty-list>
    </div>
  </div>
</ng-container>

<ng-container *inPopulation="[populations.Pts, populations.Suite]">
  <fgb-not-found-page></fgb-not-found-page>
</ng-container>
